var _path, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.907,6.464s-2.674-1.669-5.187-1.669-3.881,1.669-6.515,1.669-6.112-1.669-6.112-1.669v10.593s3.478,1.669,6.112,1.669,4.001-1.669,6.515-1.669,5.187,1.669,5.187,1.669V6.464Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.72,
    y1: 15.388,
    x2: 15.72,
    y2: 4.795
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.205,
    y1: 6.464,
    x2: 9.205,
    y2: 17.057
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.093,
    y1: 2.62,
    x2: 3.093,
    y2: 21.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.23a1240981a5cf041be78322a9c36995.svg";
export { ForwardRef as ReactComponent };